/* global axios */
import ApiClient from './ApiClient';

// Consentimento OAuth do fleapchat-mcp (tela /app/mcp/conectar). Sem accountScoped:
// a conta vai no corpo, porque o usuário escolhe qual na própria tela.
class McpOauthAPI extends ApiClient {
  constructor() {
    super('mcp_oauth', {});
  }

  criarHandoff({ pedidoId, accountId }) {
    return axios.post(`${this.url}/handoffs`, {
      pedido_id: pedidoId,
      account_id: accountId,
    });
  }
}

export default new McpOauthAPI();
